import { Injectable } from '@angular/core';
import {  DialogButtonColour, DialogComponent } from '@shared/components/dialog/dialog.component';
import { BsModalService } from 'ngx-bootstrap/modal';
import { of } from 'rxjs';
import { ModalSetting } from '../modal-setting';

export enum AlertType {
  Positive,
  Negative
}

export enum AlertSize {
  Small,
  Medium,
  Large
}

export interface AlertDialogOptions {
  confirmLabel?: string;
  title: string;
  message: string;
  type?: AlertType;
  preformatted?: boolean;
  size?: AlertSize;
}

@Injectable({
  providedIn: 'root'
})
export class AlertDialogService {
  private modalRef: any;

  constructor(private modalService: BsModalService) { }

  public confirm(
    options: AlertDialogOptions) {
    const confirmationColour = options.type === AlertType.Positive ? DialogButtonColour.action : DialogButtonColour.danger
    this.modalRef?.hide();
    const content = {
      title: options.title,
      message: options.message,
      preformatted: options.preformatted || false,
      buttons: [        
        {
          label: options.confirmLabel || 'Yes',
          action: of([]),
          complete: () => {
            this.modalRef?.hide();
          },
          colour: confirmationColour
        }
      ]
    };
    
    if (options.size === AlertSize.Medium) {
      this.modalRef = this.modalService.show(DialogComponent, ModalSetting.createMediumDialog(content));
    } else if (options.size === AlertSize.Large) {
      this.modalRef = this.modalService.show(DialogComponent, ModalSetting.createLargeDialog(content));
    } else {
      this.modalRef = this.modalService.show(DialogComponent, ModalSetting.createDialog(content));
    }
  }

}